import {
  createGalleryStore,
  CreateRegistrationStoreProvider,
} from 'components/CreateRegistration/CreateRegistrationStore';
import { renderComponent } from 'utils/RenderingUtils';
import { IEitherOrDataDefinitionsDialogProps } from './EitherOrInputDataDialog';

export async function renderEitherOrInputDataDialog(
  container: HTMLElement,
  props: IEitherOrDataDefinitionsDialogProps,
  callback?: () => void
) {
  const { EitherOrInputDataDialog } = await import('components/EitherOrDataDefinitions/EitherOrInputDataDialog');

  return renderComponent({
    container,
    component: (
      <CreateRegistrationStoreProvider createStore={createGalleryStore}>
        <EitherOrInputDataDialog {...props} />
      </CreateRegistrationStoreProvider>
    ),
    callback,
    autoUnmount: false,
  });
}
